import React, { Component, Fragment, ReactNode } from 'react';
import Icon from '../icons/Icon';
import { DeploymentStatus } from '../constant/Constants';
import LanguageUtil from '../util/LanguageUtil';

class ItemStatusComponent extends Component<Props> {
  public render(): ReactNode {
    const item = this.getItem();
    const { containerClassName } = this.props;
    return (
      <div
        data-testid={this.props['data-testid'] ?? 'component_status_text'}
        className={`${containerClassName}  group flex min-w-[84px] w-[100px] max-w-[150px] ${item.mainColor} gap-x-1 px-1  justify-center  rounded-full h-6 items-center`}
      >
        <Fragment>
          <Icon icon={item.icon} size={14} className={`${item.textColor}`} />
        </Fragment>
        <Fragment>
          <p className={`text-xs 2xl:text-md  ${item.textColor}`}>{item.text}</p>
        </Fragment>
      </div>
    );
  }

  private getItem = () => {
    const { status } = this.props;
    switch (status) {
      case 'ACTIVE':
        return {
          mainColor: 'bg-[#ECFDF3]',
          textColor: 'text-[#027A48]',
          icon: 'check',
          text: LanguageUtil.get({ id: 'common.status.active', defaultMessage: 'Active' }),
        };
      case 'DRAFT':
      case undefined:
        return {
          mainColor: 'bg-[#F4F3FF]',
          textColor: 'text-[#5925DC]',
          icon: 'draft_orders',
          text: LanguageUtil.get({ id: 'common.status.draft', defaultMessage: 'Draft' }),
        };
      case 'FAILED':
        return {
          mainColor: 'bg-[#FFF1F3]',
          textColor: 'text-[#C01048]',
          icon: 'error',
          text: LanguageUtil.get({ id: 'common.status.failed', defaultMessage: 'Failed' }),
        };
      case 'SCHEDULED':
        return {
          mainColor: 'bg-[#F2F4F7]',
          textColor: 'text-[#4F4F4F]',
          icon: 'schedule',
          text: LanguageUtil.get({ id: 'common.status.scheduled', defaultMessage: 'Scheduled' }),
        };
      case 'RESTORING':
        return {
          mainColor: 'bg-[#F2F4F7]',
          textColor: 'text-[#4F4F4F]',
          icon: 'cancel',
          text: LanguageUtil.get({ id: 'common.status.restoring', defaultMessage: 'Restoring' }),
        };
      default:
        return {
          mainColor: 'bg-[#F2F4F7]',
          textColor: 'text-[#4F4F4F]',
          icon: 'cancel',
          text:
            status == undefined
              ? LanguageUtil.get({ id: 'common.status.unknown', defaultMessage: 'Unknown' })
              : status.substring(0, 1).toUpperCase() + status.substring(1, status.length).toLowerCase(),
        };
    }
  };
}

interface Props {
  status?: DeploymentStatus | undefined;
  containerClassName?: string;
  'data-testid'?: string;
}

export default ItemStatusComponent;
